// extracted by mini-css-extract-plugin
module.exports = {"text":"PaginatorSize_text__1jlAs","selectText":"PaginatorSize_selectText__1clss","selectorWrapper":"PaginatorSize_selectorWrapper__1BnZb"};